<template>
  <div class="">
    <div class="timeline-wrapper w-100 row m-0 p-0">
      <div class="col timeline-card p-3">
        <h4 class="text-uppercase text-left timeline-title">Inscription</h4>
        <h6 class="text-left date-title">Du 27 Octobre au 09 Novembre 2025</h6>
        <p class="text-justify">Ouverture des inscriptions en ligne.</p>
      </div>
      <div class="col timeline-card my-2 my-md-0 mx-md-2 p-3">
        <h4 class="text-uppercase text-left timeline-title">
          Qualifications en ligne
        </h4>
        <h6 class="text-left date-title">Du 12 au 18 Novembre 2025</h6>
        <p class="text-justify">
          Tournoi en ligne sur une semaine, permettant aux
          meilleurs joueurs et équipes de se qualifier pour la grande finale.
        </p>
      </div>
      <div class="col timeline-card p-3">
        <h4 class="text-uppercase text-left timeline-title">Grande Finale</h4>
        <h6 class="text-left date-title">Le 22 Novembre 2025</h6>
        <p class="text-justify m-0">
          Grande finale en présentiel au centre gaming WiGame au sein du club
          Wifaq, avec streaming en direct des demi-finales et finales.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TimeLine",
  data() {
    return {};
  },
};
</script>
<style lang="css" scoped>
.timeline-card {
  color: black;
  background-color: white;
  border: 2px solid var(--pink-variant);
  min-height: 150px;
  border-radius: 8px;
}
.timeline-title {
  font-weight: 900;
  font-style: italic;
}
.date-title {
  color: var(--pink-variant);
  font-weight: 500;
}
</style>
